export default (value) => {
  const segments = value.split('_');
  const [name, volume] = segments;
  return { name, volume };
};
